{
	"browserNotSupported": "Your browser does not support embedded videos.",
	"youtubeVideoPlayer": "YouTube video player"
}
